import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import { fetchTenants } from '../catalog/hierarchy';

export function useTenantEntities() {
  const catalogApi = useApi(catalogApiRef);

  const { value, loading, error } = useAsync(
    () => fetchTenants(catalogApi),
    [catalogApi],
  );

  return { items: value ?? [], loading, error };
}
